// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1QrM-","content":"RecentSearches_content__2YYi1"};